import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { Source } from "../../../Data/Art57Data/Source";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSourceType extends Art57Node {
    constructor(injector: Injector, parent: Art57Node) {
      super(
        injector,
        new Source(new FieldDefinition(injector)),
        '{param1}{param2}{param3}'
      );
  
      this.parent = parent;
      this.labelNodeName = 'Source';
      this.data.model.operationtype = 1;
      this.ioc!.get(Art57Section).generateNumColumValue(this);
      this.refreshLabel();
    }
  
    override refreshLabel(): void {
      const param1 = this.ioc!.get(LookupGetService).retrieveValueFromCache('operationtype',this.data.model.operationtype);
      const param2 = this.data.model && this.data.model.operationtype && this.data.model.operationtype === 1?'':'- ' + this.data.model.ev_Code;
      let param3 = '';

      if (this.data && this.data.model && this.data.model.sourcename){
        param3 = ' - ' + this.data.model.sourcename;
      } 
      
      this.label = this.labelTemplate.replace('{param1}',param1).replace('{param2}',param2).replace('{param3}',param3);
    }
  
  override getListItem(): any[] {
    return [
      this.data.model && this.data.model.ev_Code
        ? this.data.model.ev_Code
        : '-',
      this.data.model && this.data.model.operationtype
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache(
          'operationtype',
          this.data.model.operationtype
        )
        : '-',
      this.data.model && this.data.model.sourcename
        ? this.data.model.sourcename
        : 'Source Name',
      '',
    ];
  }

    override cloneNode(newParent: Art57Node): Art57Node {
      let clonedNode: TreeNodeSourceType = new TreeNodeSourceType(
        this.ioc!,
        newParent
      );
  
      const currentLocalNumber = this.ioc!.get(LookupGetService).getNodeLocalNumber(clonedNode, this);
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.data.model.localnumber = currentLocalNumber;
      this.ioc!.get(LookupGetService).fixLocalNumber(clonedNode.data.model.localnumber);

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

  
      return clonedNode;
    }

    override validateBusinessRules(): any[] {
      const sameModelValuesBusinessErrors = ErrorControlUtil.sameModelValues(this);
      let businessRulesErrors = [];

      if (sameModelValuesBusinessErrors.length>0){
        businessRulesErrors.push(...sameModelValuesBusinessErrors);
      }

       return businessRulesErrors;
    }
  }